const THEME = {
  colors: {
    primary: "#003E51",
    primaryHover: "#002e3d",
    secondary: "#f5f5f5",
    // Add more colors as needed
  success: "#16a34a", // green-600
  danger: "#dc2626", // red-600
  warning: "#d97706", // amber-600
  info: "#003E51", // align info to brand primary (avoid blue)
  },
  // You can add more theme variables here
  spacing: {
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
  },
  borderRadius: {
    default: "0.25rem",
    rounded: "0.5rem",
  },
  // Update component styles
  components: {
    // Input styling
    input: {
      classNames: {
        inputWrapper: [
          "border-gray-300 dark:border-gray-700", // Default border when not focused/hovered (light/dark)
          "group-data-[focus=true]:border-[#003E51]", // Add this line for regular focus
          "group-data-[focus-visible=true]:border-[#003E51]", // Primary color when focused
          "group-data-[focus-visible=true]:ring-0",
          "group-data-[focus-visible=true]:ring-offset-0",
          "group-data-[hover=true]:border-[#003E51]/70",
          "bg-white dark:bg-gray-900"
        ]
      }
    },
    
    // Select styling (matches input styling)
    select: {
      classNames: {
        trigger: [
          "border-gray-300 dark:border-gray-700 !important", // Border with dark variant
          "data-[focus=true]:border-[#003E51] !important", // Force primary color on focus
          "data-[hover=true]:border-[#003E51]/70 !important", // Force hover color
          "ring-0 !important", // Remove default ring
          "outline-none !important",
          "bg-white dark:bg-gray-900 !important"
        ],
        // Target additional select parts if needed
  base: "outline-none",
  value: "text-gray-900 dark:text-gray-100",
  listbox: "bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 border-none",
  popoverContent: "bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-lg dark:shadow-none"
      }
    }
  }
};

export default THEME;